import { styles } from "../Style";
import { KAGames } from "./KAGames.js";
import { useEffect } from 'react';
import * as PIXI from "pixi.js";

export function KAGame(props) {
    // useEffect(() => {
    //     const script = document.createElement('script');
      
    //     script.src = "https://cdn.jsdelivr.net/processing.js/1.4.8/processing.min.js";
    //     script.async = true;
      
    //     document.body.appendChild(script);
      
    //     return () => {
    //         document.body.removeChild(script);
    //     }
    // });
    useEffect(() => {
        const App = PIXI.Application;
        const app = new App();
    });

    // We have to loop throught the array KAGames and turn them into 

    return (
        <div style={styles.KAGame}>
            <div id="output" className="_c469y9">
                <iframe id="output-frame" className="_1ib5jubf" sandbox="allow-pointer-lock allow-same-origin allow-scripts" src="https://www.kasandbox.org/computer-programming/exec/pjs?lang=en&amp;v=221114-1441-0242811df459&amp;host=www.khanacademy.org" data-src="https://www.kasandbox.org/computer-programming/exec/pjs?lang=en">
                </iframe>
                <canvas className="scratchpad-draw-canvas" width="600" height="500">
                </canvas>
                <div className="overlay disable-overlay">
                </div>
                <div className="scratchpad-canvas-loading">
                    <div className="_1o3zyidr">
                        
                    </div>
                    <span className="hide-text">Loading...</span>
                </div>
                <div className="overlay error-overlay"></div>
                <div className="tipbar ui-draggable">
                </div>
            </div>
            <canvas id="mycanvas"></canvas>
        </div>
    );
}